import { SCHOOL_DISTRICT, SCHOOL_LOCATION, SCHOOL_NAME } from "../../constants";
import SchoolLogo from "../shared/SchoolLogo";

export default function Footer() {
    return (
        <section className="space-y-4 bg-primary py-1 text-center text-white">
            <div className="flex_center flex-col space-y-8 px-4 py-1">
                <div className="flex max-w-6xl flex-wrap items-center justify-center gap-2 text-center">
                    <SchoolLogo />
                    <span>
                        {`${SCHOOL_NAME} is an established school located in ${SCHOOL_LOCATION}, ${SCHOOL_DISTRICT} and is affiliated to the PSEB, India.`}
                    </span>
                </div>
                <p>
                    <span className="text-white">
                        © Copyright Protected 2024
                    </span>
                    - {SCHOOL_NAME}
                </p>
            </div>
        </section>
    );
}
